import { Link } from 'react-router-dom';
import { PageShell } from '../components/PageShell';
import { LoadingState, ErrorState, Toast } from '../components/feedback/States';
import { MaterialIcon } from '../components/MaterialIcon';
import { MobileBottomNav } from '../components/MobileBottomNav';
import { useGame } from '../state/gameContext';
import { getRuntimeModeLabel } from '../state/runtimeGameProvider';

export default function StatesPage() {
  const { reset, state, runtimeMode, connectionStatus } = useGame();

  return (
    <PageShell mainClassName="pt-24 pb-32 px-margin-mobile md:px-margin-desktop max-w-7xl mx-auto min-h-screen flex flex-col gap-12">
      <div className="space-y-2">
        <h1 className="font-headline-md text-headline-md text-primary">System Status</h1>
        <p className="text-on-surface-variant max-w-xl">
          Previewing game-state visuals for connectivity issues, room availability, and lobby status.
        </p>
        {state.roomCode && (
          <p className="text-label-sm text-secondary">
            Active room: {state.roomCode} · mode: {runtimeMode === 'server' ? getRuntimeModeLabel() : 'mock'}
            {runtimeMode === 'server' ? ` · ${connectionStatus}` : ''}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-gutter">
        <LoadingState title="Disconnected" message="Hold tight..." />
        <ErrorState
          title="Room Not Found"
          message="That party doesn't exist. It might have ended or the link is broken."
          actionLabel="Back to Home"
        />
        <div className="relative bg-surface-container/90 backdrop-blur-2xl border border-white/10 rounded-xl p-stack-lg flex flex-col items-center justify-center min-h-[320px] shadow-xl overflow-hidden">
          <div className="absolute w-64 h-64 bg-primary/10 rounded-full blur-3xl pulse-glow" />
          <div className="relative z-10 flex flex-col items-center">
            <MaterialIcon name="construction" className="text-primary text-6xl mb-6 animate-bounce" />
            <h3 className="font-headline-md-mobile text-headline-md-mobile mb-2">Waiting for Host</h3>
            <p className="text-on-surface-variant italic font-medium">Host is tinkering with settings...</p>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <h2 className="font-headline-md text-headline-md text-secondary mb-6">Toast Components</h2>
        <div className="flex flex-wrap gap-6">
          <Toast title="Player Joined" message="NightOwl entered the lobby" variant="success" />
          <Toast title="Low Connection" message="Sync may be delayed" variant="warning" />
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-4 items-center">
        <button
          type="button"
          onClick={reset}
          className="px-4 py-2 rounded-lg bg-error/20 text-error font-label-bold hover:bg-error/30 transition-colors"
        >
          Reset Demo State
        </button>
      </div>

      <div className="mt-4">
        <h2 className="font-headline-md text-headline-md text-on-surface-variant mb-4">Demo navigation</h2>
        <div className="flex flex-wrap gap-2">
          {[
            ['/', 'Home'],
            ['/create', 'Create'],
            ['/join', 'Join'],
            ['/lobby', 'Lobby'],
            ['/game', 'Game'],
            ['/write-in', 'Write-In'],
            ['/judge', 'Judge'],
            ['/round-winner', 'Round Winner'],
            ['/game-over', 'Game Over'],
          ].map(([to, label]) => (
            <Link key={to} to={to} className="px-3 py-1 rounded-lg bg-surface-container-high text-sm hover:bg-surface-variant transition-colors">
              {label}
            </Link>
          ))}
        </div>
      </div>

      <MobileBottomNav active="/states" />
    </PageShell>
  );
}
